import * as url from "../url_helper";

import { post } from "../api_helper";

export const addSubCategory = data => post(url.ADD_SUB_CATEGORY, data);

export const getSubCategoryList = data => post(url.GET_SUB_CATEGORY, data);

export const getOneSubCategory = data => post(url.GET_ONE_SUB_CATEGORY, data);

export const editSubCategory = data => post(url.EDIT_SUB_CATEGORY, data);

export const getCategoryList = data => post(url.GET_CATEGORY_LIST, data);

export const deleteSubCategory = data => post(url.DELETE_SUB_CATEGORY, data);